namespace GeniuzPOS.InitialData {
    export class PsCustomerSurveyColumns {
        static columnsKey = 'InitialData.PsCustomerSurvey';
    }
}
